import { gql } from "@apollo/client";

import { JOB_FIELDS } from "./fragments";

export const CAMPAIGN_START_VAN_SAVED_LIST_IMPORT = gql`
  ${JOB_FIELDS}
  mutation campaignStartVanSavedListImport($campaignId: ID!, $listId: Int!) {
    campaignImportVanContacts(id: $campaignId, savedListId: $listId) {
      id
      contactImportJob {
        ...JobFields
      }
    }
  }
`;

export const CAMPAIGN_START_CSV_IMPORT = gql`
  ${JOB_FIELDS}
  mutation campaignUploadContacts(
    $campaignId: ID!
    $uploadToken: String!
    $columnMappings: CampaignUploadContactsColumnMappingInput!
    $estimatedRowCount: Int!
  ) {
    campaignUploadContacts(
      id: $campaignId
      uploadToken: $uploadToken
      columnMappings: $columnMappings
      estimatedRowCount: $estimatedRowCount
    ) {
      id
      contactsUpload {
        type
        visibility
        contentType
        fileName
      }
      contactImportJob {
        ...JobFields
      }
    }
  }
`;
